import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "volume-slider" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { for: "volume" }, "🔊 Volume 🔊", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _withDirectives(_createElementVNode("input", {
      type: "range",
      id: "volume",
      min: "0",
      max: "1",
      step: "0.01",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentVolume) = $event)),
      onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateVolume && _ctx.updateVolume(...args))),
      class: "slider"
    }, null, 544), [
      [_vModelText, _ctx.currentVolume]
    ])
  ]))
}